class togglePanel {
    constructor(buttonClassName, panelClassName) {
        this.buttonClassName = buttonClassName;
        this.panelClassName = panelClassName;
        this.buttonElements = document.getElementsByClassName(buttonClassName);
        this.panelElements = document.getElementsByClassName(panelClassName);
        this.attachListeners();
    }
  
    attachListeners(){
        for (let i = 0; i < this.buttonElements.length; i++) {
            this.buttonElements[i].addEventListener("click", () => this.toggle(i));
        }
    }
  
    toggle(i) {   
            event.target.classList.toggle(this.buttonClassName + "-active");
            let panel = this.panelElements[i];
            if (panel.style.maxHeight) {
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            }
    }
}
  
